// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path d=\"M4 3a2 2 0 100 4h12a2 2 0 100-4H4z\"/> <path fill-rule=evenodd d=\"M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z\" clip-rule=evenodd /> </svg> ";
// Exports
module.exports = code;